import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import LocaleTag from '../LocaleTag';
import DefaultStar from '../DefaultStar';
import styles from './style.module.less';
const SpeakerNameText = ({ locale, name, isDefault = false, variantCount, size = 'default', }) => {
    const displayLocale = locale !== null && locale !== undefined;
    return (_jsxs("span", { className: clsx(styles.nameText, size === 'small' && styles.nameTextSmall), children: [displayLocale && _jsx(LocaleTag, { locale: locale }), name, variantCount !== undefined && variantCount > 0 && (_jsx("span", { className: styles.variantCount, children: ` (${variantCount})` })), isDefault && _jsx(DefaultStar, { marginLeft: true })] }));
};
export default SpeakerNameText;
